import { Icon } from "@dmm-com/rocket-web-ui-library";
import { memo } from "react";
import * as Styled from "./style";
import { useRouter } from "next/router";
import { NextLink } from "~/components/blocks/common/next-link";
import { PriceDownTooltip } from "~/components/blocks/layout/global-navi/common/price-down-tooltip";
import { getParentDir } from "~/components/blocks/layout/global-navi/util/getParentDir";
import { PATHS } from "~/const/paths";
import { useClient } from "~/hooks/use-client";

import { useAuth } from "~/provider/auth";
import { uriConverter } from "~/util/uri-converter";

const MENU_NAME = "マイアイテム";

export const MyMenuItem = memo(() => {
  const { isLoggedIn } = useAuth();
  const isClient = useClient();

  const { asPath } = useRouter();
  const url = isClient ? location.href : `${process.env.NEXT_PUBLIC_FRONT_URL}${asPath}`;
  const backUrl = uriConverter.encode(url);
  const redirectUrl = `${process.env.NEXT_PUBLIC_LOGIN_ENDPOINT}${backUrl}`;
  const myMenuIsActive = asPath.startsWith(getParentDir(PATHS.MY_BOOKMARK));

  return isLoggedIn ? (
    <Styled.LIList isActive={myMenuIsActive}>
      <NextLink href={PATHS.MY_BOOKMARK}>
        <Styled.DivItem isActive={myMenuIsActive}>
          <Icon name="signPlus" size="XL" />
          {MENU_NAME}
        </Styled.DivItem>
      </NextLink>
      <PriceDownTooltip isDesktop={false} />
    </Styled.LIList>
  ) : (
    <Styled.LIList isActive={myMenuIsActive}>
      <a href={redirectUrl}>
        <Styled.DivItem isActive={myMenuIsActive}>
          <Icon name="signPlus" size="XL" />
          {MENU_NAME}
        </Styled.DivItem>
      </a>
    </Styled.LIList>
  );
});

MyMenuItem.displayName = "MyMenuItem";
